import { TableCellProps } from "@mui/material"

const headCellProps: TableCellProps = {
  align: "center",
  sx: {
    backgroundColor: "#1A428A",
    color: "#fff",
    fontWeight: "bold",
    height: "32px",
    boxShadow: " #00000022 1.95px  0px 2.6px",
    paddingY: "12px",
    paddingX: 3,
    border: "0.5px solid #E4E4E4",
  },
}

const bodyCellProps: TableCellProps = {
  align: "center",
  sx: {
    height: "48px",
    border: "0.5px solid #E4E4E4",
    boxShadow: "#00000022 1.95px 0px 2.6px",
    color: "black",
  },
}

export const defaultTableProps = {
  enableColumnActions: false,
  enableColumnFilters: false,
  enablePagination: false,
  enableSorting: false,
  enableMultiSort: false,
  enableBottomToolbar: false,
  enablePinning: true,
  enableTopToolbar: false,
  muiTablePaperProps: {
    elevation: 0,
  },
  muiTableHeadCellProps: headCellProps,
  muiTableBodyCellProps: bodyCellProps,
  muiTableBodyRowProps: {
    hover: false,
  },
  muiTableContainerProps: {
    sx: {
      overflow: "scroll",
      height: "70vh",
    },
  },
  enableStickyHeader: true,
  enableStickyFooter: true,
}
